<template>
    <div class="modal fade" v-bind:id="modalId" tabindex="-1" role="dialog" aria-labelledby="informationPopupModallLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"></span></button>
                    <h2 class="modal-title">
                        <slot name="header"></slot>
                    </h2>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    export default {
        props: {
            modalId: {
                type: String,
                required: true
            },
            info: {
                type: Object, // communication channel with parent component
                required: false,
                default: function () {
                    return {
                        max_chars: 0
                    };
                }
            }
        },
        created: function () {
            Event.$on(this.modalId, this.onPopupInvokeModal);
        },
        beforeDestroy: function () {
            Event.$off(this.modalId, this.onPopupInvokeModal);
        },
        methods: {
            onPopupInvokeModal: function (payload) {
                Object.assign(this.info, payload);
                $('#' + this.modalId).modal('show');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// information-popup.vue?51d4b921